"use strict";
// import Dict from '@baifendian/adherev-util-dict';
// import Intl from '@baifendian/adherev-util-intl';
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    initStatic: function () { },
    initRemote: function () { },
};
